import financialAssistanceReferralDetailsPropType from './financialAssistanceReferralDetailsPropType';

export { financialAssistanceReferralDetailsPropType };
